export default __webpack_public_path__ + "static/media/cert-senior-manager-hkgcsmeaa.bf304db0.jpg";